/**
 * The one call the demo visitor can "book", shared between the mocked scheduler
 * (`demo/stubs/reactCalendly.tsx`) and the `member-calendly-links/` handler.
 *
 * Prod persists the booking on Calendly's side and the member's calendar links come back
 * `Scheduled`. The demo has neither, so the stub records the slot here and the handler reads it —
 * which is what lets the Message Center footer flip from "Schedule a call with us" to the booked
 * card after the confirmation, and back to unbooked on reload. Module-scoped, like the rest of the
 * demo's session state.
 */
let scheduledStartTime: string | null = null;

export function setDemoScheduledCall(startTime: string): void {
    scheduledStartTime = startTime;
}

export function getDemoScheduledCall(): string | null {
    return scheduledStartTime;
}
